import * as Sentry from '@sentry/gatsby';
import { sentryConfigClaims } from '@agria/utils/src/sentryConfigClaims';

Sentry.init(sentryConfigClaims);
